import PropTypes from 'prop-types';
import { Progress } from 'antd';
import { GalleryUploadStatus } from '../../constants/galleryUpload';

const getProgressStatusLabel = (status, trans) => {
  if (status === GalleryUploadStatus.SUCCESS) {
    return trans('GALLERY_UPLOAD_STATUS_SUCCESS');
  }

  if (status === GalleryUploadStatus.FAILED) {
    return trans('GALLERY_UPLOAD_STATUS_FAILED');
  }

  if (status === GalleryUploadStatus.UPLOADING) {
    return trans('GALLERY_UPLOAD_STATUS_UPLOADING');
  }

  return trans('GALLERY_UPLOAD_STATUS_QUEUED');
};

const UploadProgressTray = ({ trans, uploads }) => {
  if (!uploads || uploads.length === 0) {
    return null;
  }

  return (
    <div className="gallery-upload-progress-tray" role="status" aria-live="polite">
      <div className="gallery-upload-progress-header">
        <span>{trans('GALLERY_UPLOAD_PROGRESS_TITLE')}</span>
      </div>
      <div className="gallery-upload-progress-list">
        {uploads.map((uploadItem) => {
          return (
            <div key={uploadItem.id} className="gallery-upload-progress-item">
              <div className="gallery-upload-progress-meta">
                <div className="gallery-upload-progress-file-name" title={uploadItem.fileName}>
                  {uploadItem.fileName}
                </div>
                <div className="gallery-upload-progress-state">
                  {getProgressStatusLabel(uploadItem.status, trans)}
                </div>
              </div>

              <Progress
                percent={Math.min(100, Math.max(0, Math.round(uploadItem.progress || 0)))}
                size="small"
                status={uploadItem.status === GalleryUploadStatus.FAILED ? 'exception' : 'active'}
                showInfo
              />

              {uploadItem.errorMessage ? (
                <div className="gallery-upload-progress-error">{uploadItem.errorMessage}</div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

UploadProgressTray.propTypes = {
  trans: PropTypes.func.isRequired,
  uploads: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      fileName: PropTypes.string.isRequired,
      status: PropTypes.oneOf(Object.values(GalleryUploadStatus)).isRequired,
      progress: PropTypes.number,
      errorMessage: PropTypes.string,
    })
  ).isRequired,
};

export default UploadProgressTray;
